export const ACTIVITY_LIST = [
  'CONVERSATIONS.ACTIVITY.ASSIGNEE.ASSIGNED_WITH_ASSIGNEE',
  'CONVERSATIONS.ACTIVITY.ASSIGNEE.SELF_ASSIGNED',
  'CONVERSATIONS.ACTIVITY.ASSIGNEE.ASSIGNED',
  'CONVERSATIONS.ACTIVITY.ASSIGNEE.REMOVED',
  'CONVERSATIONS.ACTIVITY.STATUS.AUTO_RESOLVED',
  'CONVERSATIONS.ACTIVITY.STATUS.CONTACT_RESOLVED',
  'CONVERSATIONS.ACTIVITY.STATUS.OPEN',
  'CONVERSATIONS.ACTIVITY.STATUS.PENDING',
  'CONVERSATIONS.ACTIVITY.STATUS.RESOLVED',
  'CONVERSATIONS.ACTIVITY.STATUS.SNOOZED',
  'CONVERSATIONS.ACTIVITY.STATUS.SYSTEM_AUTO_OPEN_BY_BOT',
  'CONVERSATIONS.ACTIVITY.STATUS.SYSTEM_AUTO_OPEN',
];
